import React from "react";
import { MdOutlineCancel } from "react-icons/md";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useCreateUnits } from "../../../services/stores";
import ModalLayout from "../../../components/modals/Layout";


const ProductUnits = ({ visible, handleCancelButton, restaurant_id }) => {
  const [values, setValues] = React.useState({
    name: "",
    conversion_to_base: "",
    
  });

  const { name, conversion_to_base } = values;

  const { mutate: createUnits, isLoading } = useCreateUnits();

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !conversion_to_base) return;

    createUnits(
      {
        name,
        conversion_to_base,
        branch: restaurant_id,
      },
      {
        onSuccess: () => {
          handleCancelButton(); // close modal after success
        },
      }
    );
  };

  return (
   <ModalLayout open={visible} setOpen={handleCancelButton} title={'Add Units'}>
          <ValidatorForm onSubmit={handleSubmit} autoComplete="off">
            <div className="border-t pt-5 space-y-4">
              <Box>
                <Typography>Unit</Typography>
                <TextValidator
                  fullWidth
                  value={name}
                  onChange={handleChange("name")}
                  validators={["required"]}
                  errorMessages={["name is required"]}
                  placeholder="e.g Kg , Box "
                />
              </Box>

              <Box>
                <Typography>Quantity per Unit</Typography>
                <TextValidator
                  fullWidth
                  value={conversion_to_base}
                  onChange={handleChange("conversion_to_base")}
                  validators={["required"]}
                  errorMessages={["Location is required"]}
                  placeholder="1, 24"
                />
              </Box>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={isLoading}
                sx={{ mt: 3, color: "white", fontSize: "1rem" }}
              >
                {isLoading ? (
                  <CircularProgress size={22} sx={{ color: "white" }} />
                ) : (
                  "Add Unit"
                )}
              </Button>
            </div>
          </ValidatorForm>
     </ModalLayout>
  );
};

export default ProductUnits;
